import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createAllergies } from 'apiServices/reducer/dialogApiService';
import CustomSuccessModal from '../../../components/CustomSuccessModal'; 
import '../../../styles/user.css';

const Allergies = ({ show, onHide, rowData, editForm, refreshAllergies, allergiesList, userId }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [activeAllergies, setActiveAllergies] = useState([]);
    const [errorMsg, setErrorMsg] = useState('');
    const [fieldErrors, setFieldErrors] = useState({ AllergyName: false, Reactions: false });
    const inputErrorStyle = { border: '1px solid #dc3545', boxShadow: 'none' };
    const dispatch = useDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState(''); 

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        setCurrentUser(user);
        if (rowData) {
            assignFormValues(rowData);
        }
        // Filter active allergies when allergiesList changes
        if (allergiesList) {
            const filteredActiveAllergies = allergiesList.filter(allergy => allergy.isActive); // assuming `isActive` is the property
            setActiveAllergies(filteredActiveAllergies);
        }
    }, [rowData, allergiesList]);

    useEffect(() => {
        if (show) {
            setFieldErrors({ AllergyName: false, Reactions: false });
        }
    }, [show]);

    const token = useSelector((state) => state.apiService?.token);

    const assignFormValues = (data) => {
        editForm.setFieldValue('AllergyName', data.AllergyName || '');
        editForm.setFieldValue('Reactions', data.Reactions || '');
        editForm.setFieldValue('AllergyID', data.AllergyID || null);
        editForm.setFieldValue('UserID', currentUser?.member_id || null);
    };

    const onSaveHandler = async () => {
        setErrorMsg('');
        const errors = {
            AllergyName: !editForm.AllergyName?.trim(),
            Reactions: !editForm.Reactions?.trim()
        };
        setFieldErrors(errors);
        if (errors.AllergyName || errors.Reactions) return;
        const formBody = {
            AllergyName: editForm.AllergyName,
            Reactions: editForm.Reactions,
            userId,
            token,
        };
        try {
            const response = await dispatch(createAllergies(formBody)).unwrap();
            if (response?.OutputMessage && response.OutputMessage !== 'Success') {
                // Treat "Allergy details saved successfully." as success
                if (response.OutputMessage.toLowerCase().includes('saved successfully')) {
                    setSuccessMessage(response.OutputMessage);
                    setShowSuccessModal(true);
                    refreshAllergies();
                    onHide();
                    return;
                }
                setErrorMsg(response.OutputMessage); 
                return;
            } 
            refreshAllergies();
            onHide();
        } catch (error) {
            console.error('API Error:', error);
            setErrorMsg(error?.message || 'Failed to save allergies. Please try again.');
           
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered dialogClassName="wider-modal" backdrop="static" keyboard={false}>
                <Modal.Header closeButton >
                    <Modal.Title className="modal-title-custom text-capitalize">Add Allergies</Modal.Title>
                </Modal.Header>

                <Modal.Body className="card-height">
                    {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
                    <Form autoComplete="off" noValidate>
                        <Form.Group controlId="AllergyName">
                            <Form.Label className='mb-1'>Allergy Name</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    name="AllergyName"
                                    value={editForm.AllergyName}
                                    onChange={(e) => {
                                        editForm.setFieldValue('AllergyName', e.target.value);
                                        setFieldErrors((prev) => ({ ...prev, AllergyName: false }));
                                    }}
                                    required
                                    className={fieldErrors.AllergyName ? 'error-border' : ''}
                                    style={fieldErrors.AllergyName ? inputErrorStyle : {}}
                                />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group controlId="Reactions">
                            <Form.Label className='mb-1'>Reactions</Form.Label>
                            <Form.Control
                                type="text"
                                name="Reactions"
                                value={editForm.Reactions}
                                onChange={(e) => {
                                    editForm.setFieldValue('Reactions', e.target.value);
                                    setFieldErrors((prev) => ({ ...prev, Reactions: false }));
                                }}
                                required
                                className={fieldErrors.Reactions ? 'error-border' : ''}
                                style={fieldErrors.Reactions ? inputErrorStyle : {}}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer  className='justify-content-center'>
                    <Button variant="primary" className="me-2" onClick={onSaveHandler}>
                        Save
                    </Button>
                    <Button variant="danger" className="ms-2" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            
            <CustomSuccessModal
                show={showSuccessModal}
                onHide={() => { setShowSuccessModal(false); setSuccessMessage(''); }}
                message={successMessage}
            /> 
            <style>{`.error-border { border: 1px solid #dc3545 !important; box-shadow: none !important; }`}</style>
        </>
    );
};

export default Allergies;
